import { formatCurrency, formatPercentage } from '@/components/composables/formatting'
import { type IJobSummary } from '@/interfaces'

export class JobSummary implements IJobSummary {
	quoteDraftTotal: number
	quoteUnsignedTotal: number
	contractSubtotal: number
	contractTaxTotal: number
	contractGrandTotal: number
	contractTotalPct: number
	invoiceSubtotal: number
	invoiceTaxTotal: number
	invoiceGrandTotal: number
	invoiceTotalPct: number
	paidSubtotal: number
	paidTaxTotal: number
	paidGrandTotal: number
	paidTotalPct: number
	openARSubtotal: number
	openARTaxTotal: number
	openARGrandTotal: number
	openARTotalPct: number
	unbilledSubtotal: number
	unbilledTaxTotal: number
	unbilledGrandTotal: number
	unbilledTotalPct: number
	estimatedLaborAmt: number
	estiimatedMaterialAmt: number
	estimatedSubAmt: number
	estimatedTotalAmt: number
	estimatedCMAmt: number
	estimatedCMPct: number
	identifiedLaborAmt: number
	identifiedMaterialAmt: number
	identifiedSubAmt: number
	identifiedOtherAmt: number
	identifiedTotalAmt: number
	identifiedCMAmt: number
	identifiedCMPct: number
	postedLaborAmt: number
	postedMaterialAmt: number
	postedSubAmt: number
	postedOtherAmt: number
	postedTotalAmt: number
	postedCMAmt: number
	postedCMPct: number
	committedMaterialAmt: number
	committedSubAmt: number
	committedOtherAmt: number
	committedTotalAmt: number
	varianceLaborAmt: number
	varianceMaterialAmt: number
	varianceSubAmt: number
	varianceOtherAmt: number
	varianceTotalAmt: number
	varianceLaborPct: number
	varianceMaterialPct: number
	varianceSubPct: number
	varianceOtherPct: number
	varianceTotalPct: number
	estimatedLaborHours: number
	actualLaborHours: number
	varianceLaborHours: number
	varianceLaborHoursPct: number
	constructor({
		quoteDraftTotal = 0,
		quoteUnsignedTotal = 0,
		contractSubtotal = 0,
		contractTaxTotal = 0,
		contractGrandTotal = 0,
		contractTotalPct = 0,
		invoiceSubtotal = 0,
		invoiceTaxTotal = 0,
		invoiceGrandTotal = 0,
		invoiceTotalPct = 0,
		paidSubtotal = 0,
		paidTaxTotal = 0,
		paidGrandTotal = 0,
		paidTotalPct = 0,
		openARSubtotal = 0,
		openARTaxTotal = 0,
		openARGrandTotal = 0,
		openARTotalPct = 0,
		unbilledSubtotal = 0,
		unbilledTaxTotal = 0,
		unbilledGrandTotal = 0,
		unbilledTotalPct = 0,
		estimatedLaborAmt = 0,
		estiimatedMaterialAmt = 0,
		estimatedSubAmt = 0,
		estimatedTotalAmt = 0,
		estimatedCMAmt = 0,
		estimatedCMPct = 0,
		identifiedLaborAmt = 0,
		identifiedMaterialAmt = 0,
		identifiedSubAmt = 0,
		identifiedOtherAmt = 0,
		identifiedTotalAmt = 0,
		identifiedCMAmt = 0,
		identifiedCMPct = 0,
		postedLaborAmt = 0,
		postedMaterialAmt = 0,
		postedSubAmt = 0,
		postedOtherAmt = 0,
		postedTotalAmt = 0,
		postedCMAmt = 0,
		postedCMPct = 0,
		committedMaterialAmt = 0,
		committedSubAmt = 0,
		committedOtherAmt = 0,
		committedTotalAmt = 0,
		varianceLaborAmt = 0,
		varianceMaterialAmt = 0,
		varianceSubAmt = 0,
		varianceOtherAmt = 0,
		varianceTotalAmt = 0,
		varianceLaborPct = 0,
		varianceMaterialPct = 0,
		varianceSubPct = 0,
		varianceOtherPct = 0,
		varianceTotalPct = 0,
		estimatedLaborHours = 0,
		actualLaborHours = 0,
		varianceLaborHours = 0,
		varianceLaborHoursPct = 0
	}: Partial<IJobSummary> = {}) {
		this.quoteDraftTotal = quoteDraftTotal
		this.quoteUnsignedTotal = quoteUnsignedTotal
		this.contractSubtotal = contractSubtotal
		this.contractTaxTotal = contractTaxTotal
		this.contractGrandTotal = contractGrandTotal
		this.contractTotalPct = contractTotalPct
		this.invoiceSubtotal = invoiceSubtotal
		this.invoiceTaxTotal = invoiceTaxTotal
		this.invoiceGrandTotal = invoiceGrandTotal
		this.invoiceTotalPct = invoiceTotalPct
		this.paidSubtotal = paidSubtotal
		this.paidTaxTotal = paidTaxTotal
		this.paidGrandTotal = paidGrandTotal
		this.paidTotalPct = paidTotalPct
		this.openARSubtotal = openARSubtotal
		this.openARTaxTotal = openARTaxTotal
		this.openARGrandTotal = openARGrandTotal
		this.openARTotalPct = openARTotalPct
		this.unbilledSubtotal = unbilledSubtotal
		this.unbilledTaxTotal = unbilledTaxTotal
		this.unbilledGrandTotal = unbilledGrandTotal
		this.unbilledTotalPct = unbilledTotalPct
		this.estimatedLaborAmt = estimatedLaborAmt
		this.estiimatedMaterialAmt = estiimatedMaterialAmt
		this.estimatedSubAmt = estimatedSubAmt
		this.estimatedTotalAmt = estimatedTotalAmt
		this.estimatedCMAmt = estimatedCMAmt
		this.estimatedCMPct = estimatedCMPct
		this.identifiedLaborAmt = identifiedLaborAmt
		this.identifiedMaterialAmt = identifiedMaterialAmt
		this.identifiedSubAmt = identifiedSubAmt
		this.identifiedOtherAmt = identifiedOtherAmt
		this.identifiedTotalAmt = identifiedTotalAmt
		this.identifiedCMAmt = identifiedCMAmt
		this.identifiedCMPct = identifiedCMPct
		this.postedLaborAmt = postedLaborAmt
		this.postedMaterialAmt = postedMaterialAmt
		this.postedSubAmt = postedSubAmt
		this.postedOtherAmt = postedOtherAmt
		this.postedTotalAmt = postedTotalAmt
		this.postedCMAmt = postedCMAmt
		this.postedCMPct = postedCMPct
		this.committedMaterialAmt = committedMaterialAmt
		this.committedSubAmt = committedSubAmt
		this.committedOtherAmt = committedOtherAmt
		this.committedTotalAmt = committedTotalAmt
		this.varianceLaborAmt = varianceLaborAmt
		this.varianceMaterialAmt = varianceMaterialAmt
		this.varianceSubAmt = varianceSubAmt
		this.varianceOtherAmt = varianceOtherAmt
		this.varianceTotalAmt = varianceTotalAmt
		this.varianceLaborPct = varianceLaborPct
		this.varianceMaterialPct = varianceMaterialPct
		this.varianceSubPct = varianceSubPct
		this.varianceOtherPct = varianceOtherPct
		this.varianceTotalPct = varianceTotalPct
		this.estimatedLaborHours = estimatedLaborHours
		this.actualLaborHours = actualLaborHours
		this.varianceLaborHours = varianceLaborHours
		this.varianceLaborHoursPct = varianceLaborHoursPct
	}
	// Revenue
	get qDraftTot(): string {
		return formatCurrency(this.quoteDraftTotal)
	}
	get qUnsignedTot(): string {
		return formatCurrency(this.quoteUnsignedTotal)
	}
	get conSubTot(): string {
		return formatCurrency(this.contractSubtotal)
	}
	get conTaxTot(): string {
		return formatCurrency(this.contractTaxTotal)
	}
	get conGraTot(): string {
		return formatCurrency(this.contractGrandTotal)
	}
	get conTotPct(): string {
		return formatPercentage(this.contractTotalPct)
	}
	get invSubTot(): string {
		return formatCurrency(this.invoiceSubtotal)
	}
	get invTaxTot(): string {
		return formatCurrency(this.invoiceTaxTotal)
	}
	get invGraTot(): string {
		return formatCurrency(this.invoiceGrandTotal)
	}
	get invTotPct(): string {
		return formatPercentage(this.invoiceTotalPct)
	}
	get pdSubTot(): string {
		return formatCurrency(this.paidSubtotal)
	}
	get pdTaxTot(): string {
		return formatCurrency(this.paidTaxTotal)
	}
	get pdGraTot(): string {
		return formatCurrency(this.paidGrandTotal)
	}
	get pdTotPct(): string {
		return formatPercentage(this.paidTotalPct)
	}
	get opARSubTot(): string {
		return formatCurrency(this.openARSubtotal)
	}
	get opARTaxTot(): string {
		return formatCurrency(this.openARTaxTotal)
	}
	get opARGraTot(): string {
		return formatCurrency(this.openARGrandTotal)
	}
	get opARTotPct(): string {
		return formatPercentage(this.openARTotalPct)
	}
	get unbSubTot(): string {
		return formatCurrency(this.unbilledSubtotal)
	}
	get unbTaxTot(): string {
		return formatCurrency(this.unbilledTaxTotal)
	}
	get unbGraTot(): string {
		return formatCurrency(this.unbilledGrandTotal)
	}
	get unbTotPct(): string {
		return formatPercentage(this.unbilledTotalPct)
	}

	// Costs
	get estLabAmt(): string {
		return formatCurrency(this.estimatedLaborAmt)
	}
	get estMatAmt(): string {
		return formatCurrency(this.estiimatedMaterialAmt)
	}
	get estSubAmt(): string {
		return formatCurrency(this.estimatedSubAmt)
	}
	get estTotAmt(): string {
		return formatCurrency(this.estimatedTotalAmt)
	}
	get estCMAmt(): string {
		return formatCurrency(this.estimatedCMAmt)
	}
	get estCMPct(): string {
		return formatPercentage(this.estimatedCMPct)
	}
	get idLabAmt(): string {
		return formatCurrency(this.identifiedLaborAmt)
	}
	get idMatAmt(): string {
		return formatCurrency(this.identifiedMaterialAmt)
	}
	get idSubAmt(): string {
		return formatCurrency(this.identifiedSubAmt)
	}
	get idOthAmt(): string {
		return formatCurrency(this.identifiedOtherAmt)
	}
	get idTotAmt(): string {
		return formatCurrency(this.identifiedTotalAmt)
	}
	get idCMAmt(): string {
		return formatCurrency(this.identifiedCMAmt)
	}
	get idCMPct(): string {
		return formatPercentage(this.identifiedCMPct)
	}
	get posLabAmt(): string {
		return formatCurrency(this.postedLaborAmt)
	}
	get posMatAmt(): string {
		return formatCurrency(this.postedMaterialAmt)
	}
	get posSubAmt(): string {
		return formatCurrency(this.postedSubAmt)
	}
	get posOthAmt(): string {
		return formatCurrency(this.postedOtherAmt)
	}
	get posTotAmt(): string {
		return formatCurrency(this.postedTotalAmt)
	}
	get posCMAmt(): string {
		return formatCurrency(this.postedCMAmt)
	}
	get posCMPct(): string {
		return formatPercentage(this.postedCMPct)
	}
	get comMatAmt(): string {
		return formatCurrency(this.committedMaterialAmt)
	}
	get comSubAmt(): string {
		return formatCurrency(this.committedSubAmt)
	}
	get comOthAmt(): string {
		return formatCurrency(this.committedOtherAmt)
	}
	get comTotAmt(): string {
		return formatCurrency(this.committedTotalAmt)
	}
	get varLabAmt(): string {
		return formatCurrency(this.varianceLaborAmt)
	}
	get varMatAmt(): string {
		return formatCurrency(this.varianceMaterialAmt)
	}
	get varSubAmt(): string {
		return formatCurrency(this.varianceSubAmt)
	}
	get varOthAmt(): string {
		return formatCurrency(this.varianceOtherAmt)
	}
	get varTotAmt(): string {
		return formatCurrency(this.varianceTotalAmt)
	}
	get varLabPct(): string {
		return formatPercentage(this.varianceLaborPct)
	}
	get varMatPct(): string {
		return formatPercentage(this.varianceMaterialPct)
	}
	get varSubPct(): string {
		return formatPercentage(this.varianceSubPct)
	}
	get varOthPct(): string {
		return formatPercentage(this.varianceOtherPct)
	}
	get varTotPct(): string {
		return formatPercentage(this.varianceTotalPct)
	}
	get estLabHrs(): string {
		return this.estimatedLaborHours.toFixed(2)
	}
	get actLabHrs(): string {
		return this.actualLaborHours.toFixed(2)
	}
	get varLabHrs(): string {
		return this.varianceLaborHours.toFixed(2)
	}
	get varLabHrsPc(): string {
		return formatPercentage(this.varianceLaborHoursPct)
	}
}
